import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"

const styleSheet = theme => ({
  root: {
    position: "relative",
  },

  background: {
    background: [
      `url(${require("../../../../static/images/story-background-mobile.jpg")})`,
      "50%",
      "0",
    ],
    backgroundSize: "cover",
    position: "relative",
    height: "40vh",

    [theme.breakpoints.up("sm")]: {
      height: "50vh",
      backgroundImage: `url(${require("../../../../static/images/story-background.jpg")})`,
    },
  },

  pullQuote: {
    padding: theme.spacing.unit * 3,
    background: theme.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    fontWeight: theme.typography.fontWeightLight,

    [theme.breakpoints.up("sm")]: {
      fontSize: theme.typography.pxToRem(19),
      lineHeight: 1.333,
      position: "absolute",
      bottom: "15%",
      left: "50%",
      width: "40vw",
      maxWidth: 600,
      borderRadius: theme.spacing.unit / 2,
      boxShadow: theme.shadows[4],
    },

    [theme.breakpoints.up("lg")]: {
      fontSize: "1.65em",
    },
  },
})

function Hero({ classes }) {
  return (
    <div className={classes.root}>
      <div className={classes.background} />
      <div className={classes.pullQuote}>
        I am an IBCLC board certified Lactation Consultant and I will give you non-judgmental
        support to reach your breastfeeding goals. You will be confident in feeding your infant
        helping them to grow up happy and healthy.
      </div>
    </div>
  )
}

export default withStyles(styleSheet)(Hero)



// WEBPACK FOOTER //
// ./src/views/pages/Landing/Hero.js